import { type FormikErrors, useFormikContext } from "formik";

import { Span } from "@icg360/design-system";

import { passwordValidationRules } from "consts";

import styles from "./password-validation-list.module.scss";

type PasswordValidationListProps = {
  password: string;
  passwordConfirmation: string;
};

type PasswordValidationErrors = {
  password?: string;
  passwordConfirmation?: string;
  errors?: string[];
};

export const PasswordValidationList = ({
  password,
  passwordConfirmation,
}: PasswordValidationListProps) => {
  const { errors } = useFormikContext();
  const { errors: passwordErrors }: FormikErrors<PasswordValidationErrors> =
    errors;

  const getListStyle = (rule: string) => {
    if (password || passwordConfirmation) {
      return passwordErrors?.includes(rule)
        ? styles.listItemDefault
        : styles.listItemValid;
    } else {
      return styles.listItemDefault;
    }
  };

  return (
    <div className={styles.wrapper}>
      <Span>Your password must contain:</Span>
      <ul className={styles.list}>
        {passwordValidationRules.map((rule, i) => (
          <li key={i} className={getListStyle(rule)}>
            <Span className={styles.ruleText}>{rule}</Span>
          </li>
        ))}
      </ul>
    </div>
  );
};
